import { render, staticRenderFns } from "./tasksTodayOther.vue?vue&type=template&id=42bd3c2e&"
import script from "./tasksTodayOther.vue?vue&type=script&lang=js&"
export * from "./tasksTodayOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports